import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Button, TextField, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function AdminDashboardCauses() {

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const karmaContext = useKarmaPoolContext();

    const [causes, setCauses] = useState(() => {
        return karmaContext.local.causes;
    });

    useEffect(() => {
        setCauses(karmaContext.local.causes);
    }, [karmaContext.local.causes]);

    const [selectedCauseForProof, setSelectedCauseForProof] = useState(() => {
        return null;
    });

    const [editingTwitterProofURL, setEditingTwitterProofURL] = useState("");

    const [editingThreadsProofURL, setEditingThreadsProofURL] = useState("");

    const [editingAmount, setEditingAmount] = useState(0);

    function handleEditingTwitterProofURL(event) {
        console.log("Editing twitter proof URL: " + event.target.value);
        setEditingTwitterProofURL(event.target.value);
    }

    function handleEditingThreadsProofURL(event) {
        console.log("Editing threads proof URL: " + event.target.value);
        setEditingThreadsProofURL(event.target.value);
    }

    function handleEditingAmount(event) {
        setEditingAmount(event.target.value);
    }

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();
    }

    function saveProofOfDonation(event) {

        event.preventDefault();

        console.log("Saving editing proof of donation");

        fetch(karmaContext.getURLBasePath() + 'admin/donationProof', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "causeId": selectedCauseForProof.id,
                "proofUrl": editingTwitterProofURL,
                "twitterUrl": editingThreadsProofURL,
                "threadsUrl": editingThreadsProofURL,
                "amountOfGbp": editingAmount
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setEditingThreadsProofURL("");
                setEditingTwitterProofURL("");
                setSelectedCauseForProof(null);
                karmaContext.refresh();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function PrintCausePage() {
        return (
            <>
                {selectedCauseForProof != null ? PrintCauseDonationProof() : PrintCauseRows()}
            </>
        );
    }

    function PrintCauseRows() {
        // Print the username of each user in users array

        console.log("causes: " + causes.length);

        return (
            <>
                {causes.map((cause) => {
                    return (
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
                            <Typography variant="body2" component="div" gutterBottom>
                                id={cause.id} | {cause.name} | {cause.gbpFromPreviousCyclesNotApplied} GBP waiting to be applied
                            </Typography>
                            {PrintCauseApplyDonationButton(cause)}
                        </Box>
                    );
                })}
            </>
        );
    }

    function PrintCauseApplyDonationButton(cause) {
        if (cause.gbpFromPreviousCyclesNotApplied > 0) {
            return (
                <Button
                    variant="contained"
                    sx={{ backgroundColor: "rgba(221, 221, 221, 0.875)", color: "black", fontSize: "0.8rem", width: "10rem", height: "2.0rem" }}
                    onClick={() => { 
                        setSelectedCauseForProof(cause) 
                        setEditingAmount(cause.gbpFromPreviousCyclesNotApplied)
                    }}
                >
                    Apply Donation
                </Button>
            );
        }
        else {
            // Greyed out disabled button
            return (
                <Typography variant="body2" component="div" gutterBottom>
                    No donation to apply
                </Typography>
            );
        }
    }

    function PrintCauseDonationProof() {

        return (
            <>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
                    <form
                        onSubmit={saveProofOfDonation}
                    >
                        <TextField
                            sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                            id="causeName"
                            label="Cause"
                            defaultValue={selectedCauseForProof.name}
                            variant='standard'
                            onChange={null}
                            size="small"
                            inputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <br />
                        <TextField
                            sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                            id="gbpLeftToDonate"
                            label="Amount To Donate"
                            defaultValue={selectedCauseForProof.gbpFromPreviousCyclesNotApplied}
                            variant='standard'
                            onChange={handleEditingAmount}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <br />
                        <TextField
                            sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                            id="proof"
                            label="Twitter URL"
                            defaultValue={"www.here.com"}
                            variant='standard'
                            size="small"
                            onChange={handleEditingTwitterProofURL}
                            InputLabelProps={{ shrink: true }}
                        />
                        <br />
                        <TextField
                            sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                            id="proof"
                            label="Threads URL"
                            defaultValue={"www.here.com"}
                            variant='standard'
                            size="small"
                            onChange={handleEditingThreadsProofURL}
                            InputLabelProps={{ shrink: true }}
                        />
                        <br />
                        <br />
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{ backgroundColor: "rgba(221, 221, 221, 0.875)", color: "black", fontSize: "0.8rem", width: "6.5rem", height: "2.0rem" }}>
                            Submit
                        </Button>
                    </form>
                </Box>
            </>
        );

    }

    RedirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    causesEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Admin - Causes
                    </Typography>

                    <Box>
                        {PrintCausePage()}
                    </Box>

                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardCauses;
